import React, { Component } from 'react'

import axios from 'axios'

import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'

import EmailField from '../fields/email-field'
import PasswordField from '../fields/password-field'

import signin from '../../../queries/3dmssapi/signin'

/* SigninForm functions
  *
  * constructor(props) {...}
  * componentDidMount() {...}
  * componentWillUnmount() {...}
  * showNotification = () => {...}
  * hideNotification = () => {...}
  * showErrorNotification = () => {...}
  * hideErrorNotification = () => {...}
  * handleSignin = (e) => {...}
  * render() {...}
  *
*/

const SigninForm = class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: undefined,
      email_touched: false,
      password: undefined,
      password_touched: undefined,

      allow_resubmit: false,
      error_message: 'Error during sign-in.',
      loading: false,
      notificationShow: false,
      on_dashboard: false,
      submitted: false,
      showErrorNotification: false,
      errors: false
    }

    this.cancelToken = axios.CancelToken.source()
  }

  componentDidMount() {
    try {
      if(typeof window !== `undefined` && window.location.pathname === '/dashboard') {
        this.setState({on_dashboard: true})
      }
    } catch(error) {
      console.log(error)
    }
  }

  componentWillUnmount() {
    try {
      this.cancelToken.cancel()
    } catch(error) {
      console.log(error)
    }
  }

  showNotification = () => {
    this.setState({notificationShow: true})
  }

  hideNotification = () => {
    this.setState({notificationShow: false})
  }

  showErrorNotification = () => {
    this.setState({showErrorNotification: true})
  }

  hideErrorNotification = () => {
    this.setState({showErrorNotification: false})
  }

  handleSignin = (e) => {
    e.preventDefault()
    this.setState({loading: true})

    signin(this.cancelToken, this.state.email, this.state.password)
      .then(response => {
        if (response.status === 200 && !response.data.errors) {
            this.setState({
              allow_resubmit: false,
              notificationShow: true,
              loading: false,
              submitted: true,
              showErrorNotification: false,
              errors: false
          })
          console.log(response, "sign in response")
            this.props.setSignedIn()
        } else if (response.status === 200 && response.data.errors) {
            if (response.data.errors && Array.isArray(response.data.errors)) {
              if (response.data.errors[0].message === 'Invalid password') {
                this.setState({loading: false, showErrorNotification: true, error_message: "Invalid password.", allow_resubmit: true})
              } else {
                this.setState({loading: false, showErrorNotification: true})
              }
            }
        }
      })
      .catch(error => {
        if(axios.isCancel(error)) {
          console.log(`Request canceled: ${error}`);
          this.setState({errors: true, loading: false, showErrorNotification: true});
        } else {
          console.log(error);
          this.setState({errors: true, loading: false, showErrorNotification: true});
        }
      })
  }

  render() {
    return (
      <React.Fragment>
        <Form>
          <Row>
            <EmailField
              id="signin-email-input"
              invalid_message="Please provide a valid email address."
              label="Email"
              setField={(value) => this.setState({email: value})}
              xs={12}
            />
            <PasswordField
              id="signin-password-input"
              invalid_message="Password must be at least 8 characters long."
              label="Password"
              setField={(value) => this.setState({password: value})}
              xs={12}
            />
          </Row>
        </Form>
        <Container>
          <Row>
            <Col xs={12}>
              <Alert show={this.state.notificationShow} onClose={this.hideNotification} dismissible variant="success">
                Signed in!
              </Alert>
              <Alert show={this.state.showErrorNotification} onClose={this.hideErrorNotification} dismissible variant="danger">
                {this.state.error_message}
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className="d-flex justify-content-end">
                { !this.state.errors && !this.state.loading && !this.state.submitted
                  && (!this.state.email
                  || !this.state.password)
                  &&
                  <div className="d-flex">
                    <Button className="m-2" variant="outline-primary" disabled>Sign In</Button>
                    {/* For non-modal signin or register */}
                    {this.props.register &&
                      <Button className="m-2" variant="outline-primary" onClick={() => this.props.register(true)}>Register</Button>
                    }
                  </div>
                }
                { (!this.state.errors || this.state.allow_resubmit) && !this.state.loading && !this.state.submitted
                  && this.state.email
                  && this.state.password
                  &&
                  <div className="d-flex p-2">
                    <Button className="m-2" variant="outline-primary" onClick={(e) => this.handleSignin(e)}>Sign In</Button>
                    {/* For non-modal signin or register */}
                    {this.props.register &&
                      <Button className="m-2" variant="outline-primary" onClick={() => this.props.register(true)}>Register</Button>
                    }
                  </div>
                }
                { !this.state.errors && this.state.loading &&
                  <Button className="m-2" variant="outline-success" disabled>
                    <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                    Signing in...
                  </Button>
                }
                { !this.state.errors && !this.state.loading && this.state.submitted &&
                  <React.Fragment>
                    <Button className="m-2" variant="outline-success" disabled>Signed In</Button>
                  </React.Fragment>
                }
                { this.state.errors &&
                  <Button className="m-2" variant="outline-danger" disabled>Error</Button>
                }
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    )
  }
}

export default SigninForm
